module.exports = __webpack_public_path__ + "img/m-shujuchushihua.1b521206.svg";